import { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { usePlan } from "@/lib/plan";

export function AvatarMenu() {
  const { user, logout } = useAuth();
  const plan = usePlan();
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!open) return;
    const onDoc = (e: MouseEvent) => { if (!ref.current?.contains(e.target as Node)) setOpen(false); };
    const onKey = (e: KeyboardEvent) => { if (e.key === "Escape") setOpen(false); };
    document.addEventListener("mousedown", onDoc);
    document.addEventListener("keydown", onKey);
    return () => {
      document.removeEventListener("mousedown", onDoc);
      document.removeEventListener("keydown", onKey);
    };
  }, [open]);

  const initials = (user?.name ?? "??").split(" ").map((s) => s[0]).slice(0, 2).join("");
  const close = () => setOpen(false);

  return (
    <div className="avatar-wrap" ref={ref}>
      <button type="button" className="avatar-btn" aria-haspopup="menu" aria-expanded={open}
        aria-label="Account menu" onClick={() => setOpen((o) => !o)}>
        {initials}
      </button>
      {open && (
        <div className="avatar-menu" role="menu">
          <div className="avatar-menu-head"><b>{user?.name ?? "—"}</b><span>{user?.email ?? ""}</span></div>
          {(plan.has("hr.core") || user?.is_super_admin) && (
            <Link role="menuitem" to="/me/profile" onClick={close}>My profile</Link>
          )}
          <Link role="menuitem" to="/account" onClick={close}>Account</Link>
          <button role="menuitem" type="button" onClick={() => { close(); void logout(); }}>Sign out</button>
        </div>
      )}
    </div>
  );
}
